import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private isLoaded = false;
  private gtmKey: string;

  private browserGlobals = {
    windowRef: (): any => window,
    documentRef: (): any => document,
  };

  constructor(@Inject('GOOGLE_TAG_MANAGER_KEY') gtmKey: string) {
    this.gtmKey = gtmKey;
    this.initAnalytics();
  }

  public push(event: unknown) {
    const dataLayer = this.getDataLayer();
    dataLayer.push(event);
  }

  private initAnalytics() {
    const doc = this.browserGlobals.documentRef();
    const gtmScript = doc.createElement('script');
    gtmScript.id = 'GTMscript';
    gtmScript.async = true;
    gtmScript.src = '//www.googletagmanager.com/gtm.js?id=' + this.gtmKey;
    doc.head.insertBefore(gtmScript, doc.head.firstChild);

    const ifrm = doc.createElement('iframe');
    ifrm.setAttribute('src', '//www.googletagmanager.com/ns.html?id=' + this.gtmKey);
    ifrm.style.width = '0';
    ifrm.style.height = '0';
    ifrm.style.display = 'none';
    ifrm.style.visibility = 'hidden';

    const noscript = doc.createElement('noscript');
    noscript.id = 'GTMiframe';
    noscript.appendChild(ifrm);

    doc.body.insertBefore(noscript, doc.body.firstChild);
    this.isLoaded = true;
    this.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
  }

  private getDataLayer() {
    const window = this.browserGlobals.windowRef();
    window['dataLayer'] = window['dataLayer'] || [];
    return window['dataLayer'];
  }
}
